import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { RetornaDadosRequest } from "../helpers/retorna-dados-request";
import { IFilterBrokerRequest } from "../interfaces/filter.interface";
@Injectable({
	providedIn: "root"
})
export class BrokerService {
	constructor(
		private http: HttpClient,
		private retornoStatus: RetornaDadosRequest
	) {}

	filter(request: IFilterBrokerRequest): Observable<any> {
		let params = new HttpParams();
		if (request.razaoSocial !== "" && request.razaoSocial !== undefined && request.razaoSocial !== null) {
			params = params.append("razaoSocial", request.razaoSocial);
		}
		if (request.cnpj !== "" && request.cnpj !== undefined) {
			params = params.append("cnpj", request.cnpj);
		}
		if (request.isAssessoria && request.isAssessoria !== undefined) {
			params = params.append("assessoria", request.isAssessoria.toString());
		}
		if (request.idAssessoria && request.idAssessoria !== undefined) {
			params = params.append("idAssessoria", request.idAssessoria.toString());
		}
		return this.http.get<any>(`${environment.urlApi}/BrokerToName`, { params });
	}

	getBrokerById(id: any): Observable<any> {
		let params = new HttpParams();

		if (id !== "" && id !== undefined) {
			params = params.append("id", id);
		}
		return this.http.get<any>(`${environment.urlApi}/GetBrokerById`, { params });
	}

	getAll(): Observable<any> {
		return this.http.get<any>(`${environment.urlApi}/GetBrokerAll`);
	}

	getBrokerByName(name: any): Observable<any> {
		let params = new HttpParams();

		if (name !== "" && name !== undefined && name !== null) {
			params = params.append("razaoSocial", name);
		}
		return this.http.get<any>(`${environment.urlApi}/brokerByName`, { params });
	}

	getBrokersByName(text: string): Observable<any> {
		let params = new HttpParams();
		if (text !== "" && text !== undefined && text !== null) {
			params = params.append("Text", text);
		}
		return this.http.get<any>(`${environment.urlApi}/Broker/GetBrokersByName`, { params });
	}
}
